import { Book } from "../../../../rest/models";
import { useAppDispatch, useAppSelector } from "../../../../store/hooks";
import { RequestStatusDisplay } from "../../../CommonComponents";
import { Button } from "../../../RequestRespectingInputs";
import { bookReaderActions } from "../slice";
import { RequestStatus } from "../../../../api_request/api_request";
import { useState } from "react";
import { uploadObject } from "../../../../rest/data";

export function EWRSaveButton()
{
    const appDispatch = useAppDispatch();
    const state = useAppSelector(function(state)
    {
        const sbr = state.bookReader;
        return (
        {
            book: sbr.book,
            trans: sbr.translationsByLangAndSentence,
        });        
    });
    const [request, setRequest] = useState<RequestStatus|undefined>(undefined);

    async function saveAllChanges()
    {
        const book = JSON.parse(JSON.stringify(state.book)) as Book;
        book.manually_edited = true;

        const trans = state.trans;

        for (const bl of book.booklanguage_set)
        {
            const sents = book.sentence_set;
            const lid = bl.language;
            
            const translations = [] as string[];
            for (let sid = 0; sid < sents.length; sid++)
            {
                translations.push(trans[lid + '/' + sid]);
            }

            bl.translation = translations.join('\n');
        }
                    
        const rs = await uploadObject(book, Book, appDispatch, setRequest);
        
        if (rs.success)
        {
            book.unsaved_changes = false;
            appDispatch(bookReaderActions.setBook(book));
        }
        else
        {
            window.alert('Upload failed.');
        }
    }

    return (
        <span className='ernots_EWRSaveButton'>
            <Button onClick={e => saveAllChanges()}>Save all changes</Button>
            <RequestStatusDisplay request={request}/>
        </span>)
}